import React, { useEffect, useRef, useState } from "react";
import { SearchUI } from "src/components/ui/Search";
import { SaveIcon } from "src/pages/Reports/shared/icons";
import Checkbox from "src/pages/Reports/WorkPlaceReport/components/Checkbox";

type Props = {
  closeModal: () => void;
  opened: boolean;
  saveFilter: ({ name, isDefault }: { name: string; isDefault: boolean }) => void;
};

function FavoriteFiltersModal({ closeModal, opened, saveFilter }: Props) {
  const [checked, setChecked] = useState(false);
  const [filterName, setFilterName] = useState("");
  const modalRef = useRef<HTMLDivElement>(null);

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  const handleFilterNameChange = (value: string) => {
    setFilterName(value);
  };

  const handleSaveFilter = () => {
    handleFilterNameChange("");
    saveFilter({ name: filterName, isDefault: checked });
  };

  useEffect(() => {
    if (opened) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [opened]);

  if (!opened) return null;

  return (
    <div className="fixed inset-0 bg-[#0000001a] z-50 flex items-center justify-center" onClick={handleOverlayClick}>
      <div className="shadow-custom p-[24px] tablet:p-10 bg-white rounded-xl w-[90%] max-w-[400px] tablet:w-[600px] tablet:max-w-[600px]" ref={modalRef}>
        <span className="inline-block mb-[18px] tablet:mb-9 text-[16px] tablet:text-2xl font-semibold text-black">Назовите набор фильтров</span>
        <SearchUI
          placeholder=""
          onClick={handleFilterNameChange}
          search={false}
          defaultValue={filterName}
          inputWrapperClass="w-full mb-[18px] tablet:mb-9"
        />
        <Checkbox
          title="Установить по умолчанию"
          checked={checked}
          onChange={setChecked}
          className="relative mb-[18px] tablet:mb-14 tablet:after:content-[''] tablet:after:absolute tablet:after:bottom-[-18px]
          tablet:after:w-[calc(100%+80px)] tablet:after:left-[-40px] tablet:after:h-px tablet:after:bg-[#DFE4EA]"
        />
        <div className="flex flex-col tablet:flex-row tablet:justify-between gap-[10px]">
          <button
            className="flex gap-x-2 justify-center items-center px-4 py-3 text-base font-medium bg-white rounded-md border text-darkblue hover:bg-gray-50 shadow-custom lg:px-6 sm:px-4"
            type="button"
            onClick={closeModal}
          >
            <span className="whitespace-nowrap">Отмена</span>
          </button>
          <button
            className="flex items-center border font-medium rounded-md px-4 justify-center gap-x-2
            bg-darkblue hover:bg-[#011e63] shadow-custom text-white text-base lg:px-6 py-3 sm:px-4"
            type="button"
            onClick={handleSaveFilter}
          >
            <SaveIcon />
            <span className="whitespace-nowrap">Сохранить</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default FavoriteFiltersModal;
